import { render, staticRenderFns } from "./SingleSpeciesLinks.vue?vue&type=template&id=78b5c991&scoped=true&"
import script from "./SingleSpeciesLinks.vue?vue&type=script&lang=js&"
export * from "./SingleSpeciesLinks.vue?vue&type=script&lang=js&"
import style0 from "./SingleSpeciesLinks.vue?vue&type=style&index=0&id=78b5c991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b5c991",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
